import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, throwError, Observer } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { OnboardingCoreEnum } from '../../../services/api-names';
import { SessionService } from '../../../services/session.service';
import {
  TECH_LIB_PORTAL_CONFIG,
  TechLibPortalConfig,
} from '../../../tech-lib-portal.interceptor';
import { Utils } from '../../../utils/utils';
import { ClientDataOnboardingInterface } from '../request/interfaces/client-data-onboarding.interface';
import { ClientDataOnboarding } from '../request/models/client-data-onboarding.model';
import { Serializer } from './../../../helpers/serializer/seriealizer';

@Injectable({
  providedIn: 'root',
})
export class OnboardingcoreService {
  private HttpHeaders: HttpHeaders;
  public showSignup: boolean = true;
  public showSmsVerification: boolean = false;
  public showSmsCode: boolean = false;
  public smsVerificationId: string;
  public accountConfirmed: boolean = false;
  public client = new ClientDataOnboarding();

  constructor(
    @Inject(TECH_LIB_PORTAL_CONFIG) private config: TechLibPortalConfig,
    private httpBackend: HttpBackend,
    private session: SessionService,
    private http: HttpClient,
    private serializer: Serializer
  ) {}

  private updateSession() {
    this.config.sessionToken = this.session.sessionToken;
    this.config.domain = this.session.domain;
    this.config.clientCode = this.session.clientCode;
    this.config.language = this.session.language;
  }

  public checkMail(mail: string, token: string): Observable<any> {
    this.updateSession();
    var url =
      this.config.baseApi +
      OnboardingCoreEnum.apirest_checkMail +
      '?email=' +
      mail;
    const httpclientNoHeaders = new HttpClient(this.httpBackend);
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Tower30-Domain', this.config.domain);
    headers = headers.append('Tower30-Language', this.config.language);
    headers = headers.append('tower30-captchatoken', token);

    return httpclientNoHeaders
      .get<any>(url, {
        headers,
        observe: 'body',
      })
      .pipe(
        map((res) => {
          return res;
        }),
        catchError((err) => {
          return throwError(err);
        })
      );
  }

  public createAccount(
    client: ClientDataOnboardingInterface,
    token: string,
    smsverification: string,
    language: string
  ): Observable<any> {
    this.updateSession();
    let url =
      smsverification.toString() == 'true'
        ? this.config.baseApi + OnboardingCoreEnum.createaccount2
        : this.config.baseApi + OnboardingCoreEnum.createaccount;

    const httpclientNoHeaders = new HttpClient(this.httpBackend);
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Tower30-Domain', this.config.domain);
    headers = headers.append('Tower30-Language', language);
    headers = headers.append('tower30-captchatoken', token);
    const bodyRequest = client;

    return httpclientNoHeaders.post<any>(url, bodyRequest, {
      headers,
      observe: 'body',
    });
  }

  public verificationCode(
    smsVerificationId: string,
    code: string,
    language: string
  ): Observable<any> {
    this.updateSession();
    let url = Utils.formatString(
      this.config.baseApi + OnboardingCoreEnum.activatebysms,
      [smsVerificationId, code]
    );
    const httpclientNoHeaders = new HttpClient(this.httpBackend);
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Tower30-Domain', this.config.domain);
    headers = headers.append('Tower30-Language', language);
    return httpclientNoHeaders
      .get<any>(url, {
        headers,
        observe: 'body',
      })
      .pipe(
        map((res) => {
          this.session.sessionToken = res.Token;
          this.config.sessionToken = res.Token;
          this.config.clientCode = res.Code;
          localStorage.setItem('SessionClientToken', res.Token);
          this.session.clientId = res.Id;
          localStorage.setItem('ClientId', res.Id);
          return res;
        }),
        catchError((err) => {
          return throwError(err);
        })
      );
  }

  public resendSms(
    smsVerificationId: string,
    language: string
  ): Observable<any> {
    this.updateSession();
    let url;
    url = Utils.formatString(
      this.config.baseApi + OnboardingCoreEnum.resendsms,
      [smsVerificationId]
    );
    const httpclientNoHeaders = new HttpClient(this.httpBackend);
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Tower30-Domain', this.config.domain);
    headers = headers.append('Tower30-Language', language);
    return httpclientNoHeaders
      .get<any>(url, {
        headers,
        observe: 'body',
      })
      .pipe(
        map((res) => {
          return res;
        }),
        catchError((err) => {
          return throwError(err);
        })
      );
  }

  public verificationCodeMail(
    smsVerificationId: string,
    code: string,
    language: string
  ): Observable<any> {
    this.updateSession();
    let url = Utils.formatString(
      this.config.baseApi + OnboardingCoreEnum.activatebymail,
      [smsVerificationId, code]
    );
    const httpclientNoHeaders = new HttpClient(this.httpBackend);
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Tower30-Domain', this.config.domain);
    headers = headers.append('Tower30-Language', language);
    return httpclientNoHeaders
      .get<any>(url, {
        headers,
        observe: 'body',
      })
      .pipe(
        map((res) => {
          this.session.sessionToken = res.Token;
          this.config.sessionToken = res.Token;
          this.config.clientCode = res.Code;
          localStorage.setItem('SessionClientToken', res.Token);
          this.session.clientId = res.Id;
          localStorage.setItem('ClientId', res.Id);
          return res;
        }),
        catchError((err) => {
          return throwError(err);
        })
      );
  }

  public resendMail(
    smsVerificationId: string,
    language: string
  ): Observable<any> {
    this.updateSession();
    let url;
    url = Utils.formatString(
      this.config.baseApi + OnboardingCoreEnum.resendmail,
      [smsVerificationId]
    );
    const httpclientNoHeaders = new HttpClient(this.httpBackend);
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Tower30-Domain', this.config.domain);
    headers = headers.append('Tower30-Language', language);
    return httpclientNoHeaders
      .get<any>(url, {
        headers,
        observe: 'body',
      })
      .pipe(
        map((res) => {
          return res;
        }),
        catchError((err) => {
          return throwError(err);
        })
      );
  }
}
